import Vue from 'vue'
import http from '@/fetch/http'
import * as types  from '@/vuex/types'

const state = {
  //title ------------------ start ----------------------
  showTablemodal: false,
  // 题目
  showTopic: false,
  // 票据
  showBill: false,
  //盖章
  showStamp: false,
  //画线
  showDrawline: false,
  //符号
  showSymbol: false,
  // 专业题高亮
  showGaoliang: false,
  //表格题 题目票据
  answerslide: false,
  //表格分析
  showFenximodal: false,
  //title -----------------  end ------------------------
  //slide add paper ----------------- start -----------------------
  //盖章模态层
  showslideStamp: false,
  //画线modal
  showslideLine: false,
  //符号
  showslideSymbol: false,
  //历史记录
  showslideHistory: false,
  //table 盖章 画线 选点 modal
  //盖章
  slideStampmodal: false,
  //画线
  slideLinemodal: false,
  // 盖章scrollTop
  stampScrollTop: 0,
  //slide add paper  ------------------ end ------------------------
  //学生作答统计分析
  stuAnswerStatisticData:{
    tableName:'',
    submitCnt:0,
    totalCnt:0,
    correctCnt:0,
    errorCnt:0,
    undoCnt:0,
    correctStu:[],
    errorStu:[],
    undoStu:[],
  },
  // 特殊题型学生作答结果
  speStuAnswer:{},
  // 盖章时选中的章
  selectSign: {
    id: -1
  },

  // 划线时 选中的线
  selectLine: {
    id: -1
  },
  StampLineModalFlag: false,
  //票据图片modal
  imgpreviewmodalFlag: false
}

const actions = {
  //slide 添加试题
  toogleSlidemodal({commit}, flag){
    //commit('toogleslidemodal', flag)
  },
  dragSlidemodal({commit}, flag){
    //commit('dragslidemodal', flag)
  },
  //title
  setTablemodal({commit}, type, flag) {
    commit('showtablemodal', type, flag)
  },
  setslideimodal({commit},flag) {
    commit('showslidemodal' ,flag)
  },
  setGaoliang({commit}, showgaoliang) {
    commit('showgaoliang', showgaoliang)
  },
  setFenximodal({commit},flag) {
    commit('SET_FENXI_MODAL' ,flag==1);
  },
  setstampScrollTop({commit},flag) {
    commit('stampScrollTop' ,flag)
  },
  //查找表格题单个空的学生作答分析
  getTableElemStatistics({commit},data){
    let param = data.param;
    let name = data.templateName;
    http.GetTableElemStatistics(param).then(res=>{
      if(res.msgCode==types.STATUS_OK){
        res.data.tableName = name;
        commit('SET_FENXI_MODAL',true);
        commit('SET_FENXI_DATA',res.data);
      }
    })
  },
  //查询此表格某学生的作答结果
  getTableStuAnswer({commit},param){
    http.GetTableStuAnswer(param).then(res=>{
      if(res.msgCode==types.STATUS_OK){
        commit('SET_STU_ANSWER',res.data);
      }
    })
  },
  //会计分录单个空的学生作答分析
  getAccountStatistics({commit}, data){
    let param = data.param;
    http.GetAccountStatistics(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit('SET_FENXI_MODAL', true);
        commit('SET_FENXI_DATA', res.data);
      }
    })
  },
  //查询会计分录某学生的作答结果
  getAccountStuAnswer({commit}, param){
    http.GetAccountStuAnswer(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit('SET_STU_ANSWER', res.data);
      }
    })
  },
  //盖章画线
  setSelectSign({commit}, sign){
    commit('SET_SELECT_SIGN', sign);
  },
  setSelectLine({commit}, line){
    commit('SET_SELECT_LINE', line);
  },
  //盖章画线 不能弹出input
  StampLineModal({commit},flag) {
    commit('stamplinemodal' ,flag)
  },
  //票据图片预览
  setImgPreviewModal({commit},flag) {
    commit('setimgpreviewmodal' ,flag)
  },
}

const mutations = {
  //slide add paper start ------------
  toogleslidemodal(state, flag) {
    //盖章 画线 符号 历史记录
    //flag 1 盖章 2 画线 3 符号 4 历史记录
    if(flag == 0) {
      state.showslideStamp = false;
      state.showslideLine = false;
      state.showslideSymbol = false;
      state.showslideHistory = false;
    } else if(flag == 1) {
      state.showslideStamp = !this.showslideStamp;
      state.showslideLine = false;
      state.showslideSymbol = false;
      state.showslideHistory = false;
    } else if(flag == 2) {
      state.showslideLine = !this.showslideLine;
      state.showslideStamp = false;
      state.showslideSymbol = false;
      state.showslideHistory = false;
    } else if(flag == 3) {
      state.showslideSymbol = !this.showslideSymbol;
      state.showslideStamp = false;
      state.showslideLine = false;
      state.showslideHistory = false;
    } else if(flag == 4) {
      state.showslideHistory = !this.showslideHistory;
      state.showslideLine = false;
      state.showslideSymbol = false;
      state.showslideStamp = false;
    }
  },
  //盖章选点modal
  dragslidemodal(state, flag) {
    //flag 0 关闭 1 盖章 2 画线
    if(flag == 0) {
      state.slideStampmodal = false;
      state.slideLinemodal = false;
    } else if(flag == 1) {
      state.slideStampmodal = !this.slideStampmodal;
      state.slideLinemodal = false;
    } else if(flag == 2) {
      state.slideLinemodal = !this.slideLinemodal;
      state.slideStampmodal = false;
    }
  },
  //slide add paper end ------------
  //title ------------start------------
  showtablemodal(state, type) {
    // 0 关闭 1题目  2 票据 3 盖章 4 画线 5 符号
    if (type == 0) {
      state.showTablemodal = false;
      state.showTopic = false;
      state.showBill = false;
      state.showStamp = false;
      state.showDrawline = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 1) {
      state.showTablemodal = !state.showTablemodal;
      state.showTopic = !state.showTopic;
      state.showBill = false;
      state.showStamp = false;
      state.showDrawline = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 2) {
      state.showTablemodal = !state.showTablemodal;
      state.showBill = !state.showBill;
      state.showTopic = false;
      state.showStamp = false;
      state.showDrawline = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 3) {
      state.showTablemodal = !state.showTablemodal;
      state.showStamp = !state.showStamp;
      state.showTopic = false;
      state.showBill = false;
      state.showDrawline = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 4) {
      state.showTablemodal = !state.showTablemodal;
      state.showDrawline = !state.showDrawline;
      state.showTopic = false;
      state.showBill = false;
      state.showStamp = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 5) {
      state.showTablemodal = !state.showTablemodal;
      state.showSymbol = !state.showSymbol;
      state.showTopic = false;
      state.showBill = false;
      state.showStamp = false;
      state.showDrawline = false;
      return ;
    }
  },
  // 显示题目票据modal
  showslidemodal(state, flag) {
    // 关闭
    if(flag == 0) {
      state.answerslide = false;
    }
    if(flag ==1) {
      state.answerslide = true;
      state.showFenximodal = false;
    }
  },
  showgaoliang(state) {
    state.showGaoliang = !state.showGaoliang;
  },
  // 表格分析
  ['SET_FENXI_MODAL'](state, value) {
    Vue.set(state, 'showFenximodal', value);
  },
  ['SET_FENXI_DATA'](state,data){
    Vue.set(state, 'stuAnswerStatisticData', data);
  },
  ['SET_STU_ANSWER'](state,stuAnswer){
    Vue.set(state,'speStuAnswer',stuAnswer);
  },
  stampScrollTop(state, flag){
    state.stampScrollTop = flag;
  },
  //盖章画线
  ['SET_SELECT_SIGN'](state, sign) {
    if(sign == 'cancel'){
      sign = {id:-1};
    }
    Vue.set(state, 'selectSign', sign);
  },
  ['SET_SELECT_LINE'](state, line) {
    if(line == 'cancel'){
      line = {id:-1,isStartPoint: true};
    }
    Vue.set(state, 'selectLine', line);
  },
  //盖章画线 不能弹出input
  stamplinemodal(state,flag) {
    if(flag == 'close') {
      state.StampLineModalFlag = false;
    } else if(flag == 'open') {
      state.StampLineModalFlag = true;
    }
  },
  //票据图片预览
  setimgpreviewmodal(state,flag) {
    if(flag == 'close') {
      state.imgpreviewmodalFlag = false;
    } else if(flag == 'open') {
      state.imgpreviewmodalFlag = true;
    }
  }
}
const getters = {

}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/table.js